var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"scroll-behavior":"smooth"},attrs:{"id":"app"},on:{"drop":function($event){_vm.drop_handler($event);},"dragover":function($event){_vm.dragover_handler($event);},"dragend":function($event){_vm.dragend_handler($event);}}},[_c('cover'),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.hasGithubRibbon)?_c('Ribbon',_vm._b({},'Ribbon',_vm.ribbonOptions,false)):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dfb77b0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 560
// module chunks = 1